import { FavouriteDefinition } from 'app/types-shared';

export const updateDefinitionWithReport = (report: number) => (definition: FavouriteDefinition): FavouriteDefinition => {

  return {
    ...definition,

    ...(!!report && {
      selectedReport: {
        v: report
      },

      reports: [
        ...(definition.reports || []),
        ...(!definition.reports || !definition.reports.some(r => r.report.v === report)
          ? [{
            report: { v: report }
          } as any]
          : [])
      ]
    })
  };
};
